module.exports = __webpack_public_path__ + "static/becky-20e0b12feacd621b33ea1fd9f111c496.jpg";